var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.btn.className,attrs:{"type":"button","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('btnClick')}}},[_vm._v(_vm._s(_vm.btn.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }